export const CLASS_PREVIEW = 'preview';
